<template>
  <div class="about-banner">
    <img :src="aboutBanner" alt="" />
    <div class="absolute">
      <div class="title">关于畅月</div>
      <div class="text">
        上海畅月物业管理有限公司，是一家致力于为传统物业提供新型的数字智慧物管模式的公司：通过数字化、线上化、智慧化打造综合岗位集合的指挥室。畅居数字化智慧物业平台的三个板块——“物业管理板块”和“物联网管理板块”及“智慧便民商圈板块”组成。公司项目包含：物业管理、酒店管理、市政设施管理、信息系统集成服务、物联网应用服务、信息技术咨询服务等智慧社区+数字化城市治理综合管理系统。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import aboutBanner from "../../../assets/about/aboutBanner.png";

export default {
  setup() {
    return reactive({
      aboutBanner: aboutBanner
    });
  }
};
</script>

<style scoped>
.about-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .about-banner {
    min-width: 1180px;
  }
}
.about-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  width: 1020px;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.absolute .title {
  font-size: 36px;
  color: #fff;
}
.absolute .text {
  font-size: 18px;
  color: #fff;
  margin-top: 54px;
  line-height: 30px;
}
</style>
